import Image from "next/image";
import styles from "./preview.module.css";
import { useTranslation } from "next-i18next";

export const Preview = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.preview}>
      <div className={styles.preview__background}>
        <video
          width="320"
          height="240"
          className={styles.preview__background_image}
          autoPlay
          muted
          loop
        >
          <source src="/preview_background.mp4" type="video/mp4" />
        </video>
      </div>
      <div className={styles.preview__background_cover}></div>
      <div className={styles.preview__content}>
        <div className={styles.preview__logo}>
          <Image
            src="/logo.webp?v=1"
            alt="Keperin"
            className={styles.preview__logo_image}
            width={300}
            height={220}
            priority
          />
        </div>
        <div className={styles.preview__logo_text}>
          Tu Asistente Inteligente de Inversiones
        </div>
        {/* <a
          className={styles.preview__button}
          href="#contact"
          title={t("start_now")}
        >
          {t("start_now")}
        </a> */}
      </div>
    </div>
  );
};
